// @ts-nocheck
import { Formio } from '@formio/angular';

const OriginalFileComponent = (Formio as any).Components.components.file;
const Components = (Formio as any).Components;
const Utils = (Formio as any).Utils;

export default class FormioFile extends OriginalFileComponent {
  async upload(...args: any[]) {
    this.component.options = this.component.options ? this.deleteFileOption(this.component.options) : JSON.stringify({ "withCredentials": true, "headers": { "o-auth-key": localStorage.getItem('session-Token') } })

    // Вызываем оригинальный метод
    return super.upload(...args);
  }

  async deleteFile(...args: any[]) {
    this.component.options = this.component.options ? this.deleteFileOption(this.component.options) : JSON.stringify({ "withCredentials": true, "headers": { "o-auth-key": localStorage.getItem('session-Token') } })

    // Вызываем оригинальный метод
    return super.deleteFile(...args);
  }
  deleteFileOption(data) {
    try {
      const _data = Object.assign({}, JSON.parse(data), { "withCredentials": true, "headers": { "o-auth-key": localStorage.getItem('session-Token') } });
      return JSON.stringify(_data);
    } catch (e) {
      console.error("Error parsing JSON:", e);
      return data; // Возвращаем исходные данные, если не удалось разобрать
    }
  }
}




Components.setComponent('file', FormioFile);

// // Use the table component edit form.
// UserNameComponent.editForm = componentEditForm;

// // Register the component to the Formio.Components registry.
// Components.addComponent('username', UserNameComponent);



